
import {
  Component,
  Prop,
  Vue,
  Watch,
  Model
} from 'vue-property-decorator';
	import {
		handleClipboard
	} from '@/utils/clipboard'
import Dialog from '@/components/dialog.vue';
  import {
    orderSupportdetail,
    orderSupportsendGoods
  } from '@/api/after_sales'
  import {
    getExpressList,
  } from '@/api/logistics';
@Component({
  name: 'aftersales-order',
  components: {
    'slz-dialog': Dialog,
  }
})
export default  class AftersalesOrder extends Vue{
  @Prop({default:false}) show!:boolean;
  @Prop({default:''}) SupportNo!:string;
  private fillinShow = false
  private detailmsg:any = {}

  private fillinDate:any={
    SupportNo:'',
    ExpressId:'',
    ExpressNo:'',
  }

  private expressList:any = []

  @Watch('show')
  private info(val){
    // console.log(val)
    this.fillinShow = val
    if(val){
      this.getdetail()
      this.togetExpressList()
    }
  }

  
  
    private async togetExpressList() {
      try {
        const res: any = await getExpressList({});
        this.expressList = res.Result;
      } catch (e) {
        console.log(e)
      }
    }

  private async sendgoods(){
    if(!this.fillinDate.ExpressId){
      this.$message.error('请选择物流公司')
      return 
    }else if(!this.fillinDate.ExpressNo){
      this.$message.error('请填写物流单号')
      return 
    }
    try{
      this.fillinDate.SupportNo = this.SupportNo
      let res = await orderSupportsendGoods(this.fillinDate)
      if(res.IsSuccess){
        this.$message.success('操作成功')
        // this.close()
        this.$emit('confirm')
      }
    }finally{
      //
    }
  }

  private async getdetail(){
    try{
      let res = await orderSupportdetail({
        SupportNo:this.SupportNo
      })
      if(res.IsSuccess){
        let detailmsg = res.Result
        detailmsg.SupportNo = this.$route.query.SupportNo
        detailmsg.usermsg = detailmsg.CustomerName+' '+detailmsg.CustomerPhone
        this.detailmsg = detailmsg
      }
    }finally{
      //
    }
  }

  private close(){
    this.fillinShow = false
    this.fillinDate={
      SupportNo:'',
      ExpressId:'',
      ExpressNo:'',
    }
    this.$emit('close')
  }
  private copy(event){
      let text = this.detailmsg.ReceiveName + ' ' + this.detailmsg.ReceivePhone + '\n'
                 + this.detailmsg.ReceiveProvince + this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this.detailmsg.ReceiveAddress
      handleClipboard(text, event)

  }
}
